import { render, staticRenderFns } from "./uploadintologisitics-photo.vue?vue&type=template&id=649c0c3b&scoped=true&"
import script from "./uploadintologisitics-photo.vue?vue&type=script&lang=ts&"
export * from "./uploadintologisitics-photo.vue?vue&type=script&lang=ts&"
import style0 from "./uploadintologisitics-photo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./uploadintologisitics-photo.vue?vue&type=style&index=1&id=649c0c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c0c3b",
  null
  
)

export default component.exports